import { render } from "./printLabel.vue?vue&type=template&id=58c41483&scoped=true"
import script from "./printLabel.vue?vue&type=script&lang=js"
export * from "./printLabel.vue?vue&type=script&lang=js"

import "./printLabel.vue?vue&type=style&index=0&id=58c41483&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-58c41483"

export default script